export default function asArray(n, field) {
  if (Array.isArray(n[field])) {
    return n[field]
  }
  else {
    return [n[field]]
  }
}
